import { Box } from '@mui/material';
import styled from 'styled-components';

export const CommunicationPreferencesContainerStyled = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    backgroundColor: '#ffffff',
    boxShadow: '0px 1px 10px 0px #0000003D',
    padding: theme.spacing(6),
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  })
);

export const PreferredLanguageContainerStyled = styled(Box)(({ theme }) => ({
  borderWidth: '0px 0px 1px 0px',
  borderColor: theme.palette.grey['200'],
  borderStyle: 'solid',
  marginLeft: '-2.4rem',
  marginRight: '-2.4rem',
  paddingLeft: '2.4rem',
  paddingRight: '2.4rem',
  paddingBottom: '2.4rem',
}));

export const ExtraInfoStyled = styled('div')(({ theme }) => ({
  color: theme.palette.grey['400'],
}));

export const EmailContainerStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
});

export const EmailInputContainerStyled = styled(Box)(({ theme }) => ({
  display: 'block',
  width: '50%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const EditButtonWrapperStyled = styled(Box)({
  marginLeft: 'auto',
  marginTop: '-3.5rem !important',
  marginRight: '-1.5rem !important',
  alignSelf: 'flex-end',
  height: 'fit-content',
});

export const EmptyEmailContainerStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
});

export const LabelValuePairStyled = styled(Box)({
  height: '69px',
});

export const AddEmailContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const AllowTextMessagesContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderWidth: '1px 0px 0px 0px',
  borderColor: theme.palette.grey['200'],
  borderStyle: 'solid',
  marginLeft: '-2.4rem',
  marginRight: '-2.4rem',
  padding: '2.4rem',
}));

export const TextMessageToggleContainerStyled = styled(Box)({
  display: 'block',
  alignItems: 'center',
});

export const GoPaperlessContainerStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const ImageStyled = styled('img')(({ theme }) => ({
  width: '30%',
  height: '100%',
  padding: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    width: '40%',
  },
}));

export const PaperlessImageContainerStyled = styled(Box)({
  backgroundColor: '#E6E6E6',
  height: '120px',
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
});
